import { render, staticRenderFns } from "./Total.vue?vue&type=template&id=da434bce"
import script from "./Total.vue?vue&type=script&lang=js"
export * from "./Total.vue?vue&type=script&lang=js"
import style0 from "./Total.vue?vue&type=style&index=0&id=da434bce&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports